export enum TipoCascadaEnum {
    REDUCIR_A_CERO = "REDUCIR_A_CERO",
    INCREMENTAR_A_CERO = "INCREMENTAR_A_CERO"
}